import React from 'react'
import propTypes from 'prop-types'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { buildChartJsOptionsProp } from './options'

export const RadialBarChart = (props) => {
  ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

  return (
    <div
      className={props.className}
    >
      <Pie
        options={buildChartJsOptionsProp(props.options)}
        data={props.data}
      />
    </div>
  )
}

RadialBarChart.propTypes = {
  className: propTypes.string,
  data: propTypes.object.isRequired,
  height: propTypes.string,
  options: propTypes.object,
  plugins: propTypes.array,
}

RadialBarChart.defaultProps = {
  className: '',
  height: 'medium',
  options: {},
  plugins: null,
}
